import React from 'react';

const HelpMeChooseTick = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="12" fill="url(#paint0_radial_695_3867)" />
      <path d="M15.5912 9.34058L10.6819 14.25L8.5 12.0681" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <defs>
        <radialGradient id="paint0_radial_695_3867" cx="0" cy="0" r="1" gradientTransform="matrix(-29.625 -30.9 29.2485 -171.005 25.725 24)" gradientUnits="userSpaceOnUse">
          <stop offset="0.16" stopColor="#00B0CA" />
          <stop offset="0.925" stopColor="#31B44B" />
        </radialGradient>
      </defs>
    </svg>

  );
};

export default HelpMeChooseTick;